import {
  Close as CloseIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useCourses from '../../../../hooks/useCourses';
import useStudents from '../../../../hooks/useStudents';
import { TableSkeleton } from '../../../../components/TableSkeleton';
import CustomTextField from '../../../../components/Textfield';
import CertificateDialog from '../student/CertificateDialog';
import useRegistration from '../../../../hooks/useRegistration';

const RegistrationManagement = () => {

  const [deleteStudentId, setDeleteStudentId] = useState(null);
  const [student] = useState(null);
  const [studentId, setStudentId] = useState(null);


  //hooks
  const { registrationData, isLoadingRegistrationData, removeRegistrationMutation, isRemovingRegistration } = useRegistration();
  const { courses, isCoursesLoading } = useCourses();
  const { addStudent, updateStudent, isAddingStudent, isUpdatingStudent } = useStudents();

  const { register, handleSubmit, watch, formState: { errors }, setValue } = useForm();


  console.log({ registrationData });

  // Dialog state
  const [open, setOpen] = useState(false);
  const [isEditing] = useState(false);

  const handleCloseDialog = () => {
    setOpen(false);
  };

  // const handleStudentChange = (e) => {
  //   const { name, value } = e.target;
  //   setCurrentStudent(prev => ({ ...prev, [name]: value }));
  // };

  // const handleCoursesChange = (courseId) => {
  //   setCurrentStudent(prev => {
  //     const isSelected = prev.courses.includes(courseId);
  //     return {
  //       ...prev,
  //       courses: isSelected
  //         ? prev.courses.filter(id => id !== courseId)
  //         : [...prev.courses, courseId]
  //     };
  //   });
  // };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   console.log({ file });
  //   if (file) {
  //     // In a real app, you'd handle the file upload to a server
  //     setCurrentStudent(prev => ({ ...prev, image: file }));
  //   }
  // };

  const handleSaveStudent = async (values) => {

    console.log({ values });

    const formData = new FormData();

    // Append string fields
    formData.append("name", values.name);
    formData.append("fatherName", values.fatherName);
    formData.append("enrollment_no", values.enrollment_no);
    formData.append("serial_no", values.serial_no);
    formData.append("email", values.email);
    formData.append("issued_on", values.issued_on);
    formData.append("marks", JSON.stringify(values.marks));


    // Append array fields (e.g., courses)
    values.courses.forEach((courseId, index) => {
      formData.append(`courses[${index}]`, courseId);
    });


    if (isEditing && student) {

      // Append image (assuming `values.image` contains the file)
      if (values.image && values?.image?.[0]?.name !== student?.image?.[0]?.name) {
        formData.append("image", values.image[0]);
      }

      formData.append("_id", student._id);

      await updateStudent(formData);
    } else {

      if (values.image && values?.image?.[0]) {
        formData.append("image", values.image[0]);
      }

      // setStudents(prev => [...prev, currentStudent]);
      await addStudent(formData);

    }
    handleCloseDialog();
  };

  const handleRemoveImage = () => {
    // Clear the image field
    setValue("image", []);
  };

  // const handleDeleteStudent = (studentId) => {
  //   setStudents(prev => prev.filter(student => student.id !== studentId));
  // };

  console.log({ i: watch("courses"), });
  console.log({ student });

  const handleDeleteStudent = async () => {
    await removeRegistrationMutation(deleteStudentId);
    setDeleteStudentId(null);
  };

  const selectedCourses = watch("courses") || [];  // Get selected course IDs

  // Filter subjects for the selected courses
  const coursesData = courses
    .filter((course) => selectedCourses.includes(course._id)) // Filter courses based on selected IDs



  console.log({ selectedCourses, coursesData });


  if (isLoadingRegistrationData) {
    return <TableSkeleton />;
  }


  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 2 },
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
          Registration List
        </Typography>
      </Box>

      {/* Students Table */}
      <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden', borderRadius: '8px' }}>
        <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>

              <TableRow sx={{ "& th": { fontSize: "14px", fontWeight: "bold" } }}>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Course</TableCell>
                <TableCell>Address</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {registrationData?.length > 0 ? <>
                {registrationData?.map((data) => (
                  <TableRow key={data?._id} sx={{ "& td": { fontSize: "14px" } }}>
                    <TableCell>
                      {data?.firstName}
                    </TableCell>
                    <TableCell>{data?.lastName}</TableCell>
                    <TableCell>{data?.email}</TableCell>
                    <TableCell>{data?.gender}</TableCell>
                    <TableCell>{data?.course}</TableCell>
                    <TableCell>{data?.address}</TableCell>
                    <TableCell align="right">
                      {/* <IconButton
                      color="primary"
                      onClick={() => handleOpenDialog(student)}
                      size="small"
                    >
                      <EditIcon fontSize="large" />
                    </IconButton> */}
                      <IconButton
                        color="error"
                        onClick={() => setDeleteStudentId(data?._id)}
                        size="small"
                      >
                        <DeleteIcon fontSize="large" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </> : <TableRow>
                <TableCell colSpan={7} align="center">
                  <Typography variant="h6"> No registartion found. </Typography>
                </TableCell>
              </TableRow>}


            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Student Dialog */}

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
      >
        <form onSubmit={handleSubmit(handleSaveStudent)}>
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {isEditing ? 'Edit Student' : 'Add New Student'}
              <IconButton edge="end" color="inherit" onClick={handleCloseDialog} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ maxHeight: '70vh' }}>
            <Grid container spacing={2} >
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("name", { required: "Student Name is required" })}
                  fullWidth
                  label="Student Name*"
                  error={!!errors.name} // Shows error state if validation fails
                  helperText={errors.name?.message} // Display custom error message
                />

              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }} >
                <CustomTextField
                  {...register("fatherName", { required: "Father Name is required" })}
                  fullWidth
                  label="Father's Name*"
                  error={!!errors.fatherName} // Shows error state if validation fails
                  helperText={errors.fatherName?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("enrollment_no", { required: "Enrollment No is required" })}
                  fullWidth
                  label="Enrollment No*"
                  error={!!errors.enrollment_no} // Shows error state if validation fails
                  helperText={errors.enrollment_no?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("serial_no", { required: "Serial No is required" })}
                  fullWidth
                  label="Serial No*"
                  error={!!errors.serial_no} // Shows error state if validation fails
                  helperText={errors.serial_no?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("email", { required: "Serial No is required" })}
                  fullWidth
                  label="Email*"
                  type="email"
                  error={!!errors.email} // Shows error state if validation fails
                  helperText={errors.email?.message} // Display custom error message
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <CustomTextField
                  {...register("issued_on", { required: "Issued On Date is required" })}
                  fullWidth
                  label="Issued On*"
                  name="issued_on"
                  type="date"
                  InputLabelProps={{
                    shrink: true,  // Ensures the label stays above the input for date fields
                  }}
                  error={!!errors.issued_on}  // If there's an error, show the error state
                  helperText={errors.issued_on?.message}  // Show the validation error message
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 6 }}>

                {!watch("image")?.[0]?.name &&
                  <input
                    type="file"
                    id="image"
                    accept="image/*"
                    {...register("image", {
                      required: "Student photo is required",
                      validate: (v) => (v && v.length > 0) || "Please upload a photo",
                    })}
                    style={{ display: "none" }}
                  />
                }
                <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} gap={2} mb={1}>
                  <Button
                    variant="contained"
                    component="span"
                    onClick={() => document.getElementById("image")?.click()}
                    disabled={!!watch("image")?.[0]?.name}
                    sx={{ fontSize: 15 }}
                  >
                    Choose Profile Picture
                  </Button>

                  {watch("image")?.[0]?.name && (
                    <Chip
                      label={
                        <Typography fontSize={14}>
                          {/* {truncateFileName(watch("image")?.[0]?.name)} */}
                        </Typography>
                      }
                      size="small"
                      color="primary"
                      variant="outlined"
                      onDelete={handleRemoveImage}
                      sx={{ maxWidth: '100%' }}
                    />
                  )}
                </Box>

                {errors.image && (
                  <Typography variant="caption" color="error" ml={1.5} fontSize={12}>
                    {errors.image.message}
                  </Typography>
                )}
              </Grid>

              {/* Courses Selection */}
              <Grid item size={{ xs: 12, sm: 6 }}>
                <FormControl component="fieldset" variant="standard" fullWidth>
                  <FormLabel component="legend" ><Typography fontSize={15}>Selected Courses</Typography></FormLabel>
                  {isCoursesLoading ? <CircularProgress /> : <Paper variant="outlined" sx={{ p: { xs: 1, sm: 2 } }}>
                    {courses?.length > 0 ? (
                      <FormGroup>
                        <Grid container spacing={{ xs: 0, sm: 2 }}>
                          {courses.map((course) => (
                            <Grid item xs={12} sm={6} key={course._id}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={watch("courses")?.includes(course._id) || false}
                                    value={course._id}
                                    {...register("courses", {
                                      validate: (v) => (v && v.length > 0) || "Select at least one course",
                                    })}
                                  />

                                }
                                label={<Typography fontSize={14}>{course.title}</Typography>}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </FormGroup>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No courses available. Please add courses first.
                      </Typography>
                    )}
                  </Paper>}

                  {errors.courses && (
                    <Typography variant="body2" color="error" sx={{ mt: 1, fontSize: 12, ml: 1.5 }}>
                      {errors.courses.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              {coursesData?.length > 0 && <Grid item size={{ xs: 12 }}>
                <Typography variant="h6" fontSize={18} fontWeight={600} textAlign={"center"} sx={{ borderBottom: "1px solid grey", mt: 2 }} >Subjects and Marks</Typography>



                {coursesData?.map((course, index) =>
                  <Stack key={course._id}>
                    <Typography variant="h6" fontSize={15} sx={{ mb: 1, mt: 2 }} >{index + 1}. {course.title}</Typography>
                    <TableContainer component={Paper} variant='outlined'>
                      <Table >
                        <TableHead>
                          <TableRow sx={{ "& th": { fontSize: "14px", fontWeight: "bold" } }}>
                            <TableCell>Subject</TableCell>
                            <TableCell>Full Marks</TableCell>
                            <TableCell>Obtain Marks</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {course?.subjects?.map((subject) => (
                            <TableRow key={subject._id} sx={{ "& td": { fontSize: "14px" } }}>
                              <TableCell>{subject.name}</TableCell>
                              <TableCell>{subject.marks}</TableCell>
                              <TableCell>
                                <CustomTextField
                                  {...register(`marks.${course._id}.${subject._id}`)} // Use dynamic name for each subject's marks
                                  size="small"
                                  type="number"
                                  fullWidth
                                  variant="outlined"
                                  InputProps={{ inputProps: { min: 0, max: subject?.marks || 100 } }}
                                  defaultValue={0}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Stack>)}

              </Grid>}

            </Grid>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} sx={{ fontSize: 14, color: "#454751d1" }} >Cancel</Button>
            <Button
              sx={{ fontSize: 14, background: "#454751d1" }}
              type='submit'
              variant="contained"
              disabled={isAddingStudent || isUpdatingStudent}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Student Dialog */}
      <Dialog open={!!deleteStudentId} onClose={() => setDeleteStudentId(null)} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Delete Registration
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDeleteStudentId(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 3 }}>
          Are you sure you want to delete this registration?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteStudentId(null)}
            sx={{ fontSize: 13, color: "#454751d1" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteStudent}
            sx={{ fontSize: 13 }}
            variant="contained"
            disabled={isRemovingRegistration}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <CertificateDialog
        open={!!studentId}
        onClose={() => setStudentId(null)}
        studentId={studentId}
      />

    </Box>
  );
};

export default RegistrationManagement;